import SkillCard from "./SkillCard";
import Container from "react-bootstrap/Container";
import categories from "../data/skills.json";

function SkillSection() {
  return (
    <Container>
      <section className="pt-5" id="skills">
        <h2 className="mb-4 border-bottom">Skills</h2>

        <div className="d-flex flex-wrap gap-lg-3 gap-4">
          {
            Object.values(categories).map((category, index) =>
              <SkillCard key={index} category={category} />
            )
          }
        </div>
      </section>
    </Container>
  );
}

export default SkillSection;